// Libs
import classNames from 'classnames/bind';
import { Avatar, AvatarGroup, Box, Tooltip, Zoom } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { IAvatarGroup } from '~/utils/interface/common';
import { DEFAULT_LIMIT_SURPLUS, DEFAULT_NUMBER_ONE } from '~/utils/constants/common';
import { getAvatarName, getFullName } from '~/utils/helper/common';
// Styles, images, icons
import styles from './BaseAvatarGroup.module.scss';
import { icons } from '~/assets';

type Props = {
  avatars: IAvatarGroup[];
  max?: number;
  spacing?: 'small' | 'medium' | number;
  size?: number;
  borderColor?: string;
};

const cx = classNames.bind(styles);

const BaseAvatarGroup = (props: Props) => {
  //#region Destructuring Props
  const { avatars, max = 5, spacing = 'medium', size = 24, borderColor } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <AvatarGroup
      component={'div'}
      className={cx('avatarGroup')}
      spacing={spacing}
      max={max}
      renderSurplus={(surplus) => (
        <Tooltip
          title={avatars?.slice(max - DEFAULT_NUMBER_ONE)?.map((avatar, index) => (
            <Box key={index}>{getFullName({ ...avatar })}</Box>
          ))}
          arrow
          placement='top'
          slots={{
            transition: Zoom,
          }}
        >
          {surplus < DEFAULT_LIMIT_SURPLUS ? (
            <Avatar
              style={{ border: `1px solid ${borderColor}` }}
              className={cx('surplus')}
            >{`+${surplus}`}</Avatar>
          ) : (
            <Avatar sx={{ width: size, height: size }} className={cx('surplus')}>
              <img src={icons.commonIconMoreAvatar} alt={t('common_alt_img')} className={cx('surplusMore')} />
            </Avatar>
          )}
        </Tooltip>
      )}
      slotProps={{
        surplus: {
          sx: {
            width: size,
            height: size,
          },
          style: { border: `1px solid ${borderColor}` },
        },
      }}
    >
      {avatars?.map((avatar, index) => (
        <Tooltip
          key={index}
          title={getFullName({ ...avatar })}
          arrow
          placement='top'
          slots={{
            transition: Zoom,
          }}
        >
          <Avatar
            alt={t('common_alt_img')}
            src={avatar?.avatarImage}
            sx={{ width: size, height: size }}
            style={{ border: `1px solid ${borderColor}` }}
            className={cx(cx('avatar'))}
          >
            {getFullName({ ...avatar }) && getAvatarName(getFullName({ ...avatar }))}
          </Avatar>
        </Tooltip>
      ))}
    </AvatarGroup>
  );
};

export default BaseAvatarGroup;
